<template>
  <div class="item_body">
    <input type="text" class="tem_input" placeholder="用戶名" />
    <input type="text" class="tem_input" placeholder="密碼" />
    <input type="text" class="tem_input" placeholder="確認密碼" />
    <!-- <input type="text" class="tem_input" placeholder="真实姓名（必须为汉子且与身份证一致）" /> -->
    <!-- <input type="text" class="tem_input" placeholder="请输入18位身份证号（请于身份证一致）" /> -->
    <input type="text" class="tem_input" placeholder="郵箱" />
    <!-- <input type="text" class="tem_input" placeholder="手机号码" /> -->
    <div class="protocol">
        <img class="checkimg" @click="seed" v-if="checkseed" src="../../static/img/check.png" alt="">
        <img class="checkimgs" @click="seed" v-if="!checkseed" src="../../static/img/checkboxs.png" alt="">
        已同意並閱讀《用戶服務協議》</a></div>
    <div class="com_btn" @click="showMask">註冊</div>
    <div class="pt200"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      checkseed:true
    };
  },
  mounted: function() {},
  methods: {
       onChange (e) {
        console.log(`checked = ${e.target.checked}`)
        },
        seed(){
            this.checkseed = !this.checkseed
        },
        showMask() {
            this.$emit('showMask');
        }
  }
};
</script>
<style scoped>
.item_body {
  width: 400px;
  margin:0 auto;
}
.checkimg{
    width: 16px;
    height: 16px;
    vertical-align: text-top;
    cursor: pointer;
}
.checkimgs{
    width: 18px;
    height: 18px;
    vertical-align: text-top;
    cursor: pointer;
}
.tem_input {
  width: 100%;
  height:50px;
  margin-bottom: 25px;
  border:none;
  outline: none;
  border-radius: 10px;
  padding:0 10px;
  box-sizing: border-box;
  background-color: #dcdcdc;
  font-size: 16px
}
.com_btn{
    cursor: pointer;
    width: 100%;
    height: 50px;
    line-height: 50px;
    margin-top: 30px;
    background-color: #ef653d;
    color: white;
    border-radius: 5px
}
.pt200{
    padding-bottom: 100px
}
.protocol{
    text-align: left
}
</style>



// WEBPACK FOOTER //
// src/components/register.vue